<template>
    <div class="col-md-12" style="height: 100%;">
        <div class="row" style="padding-top: 15px;padding-bottom: 15px;">
            <div class="col-md-6 pL0" style="line-height: 19px;">
                 <span class="title"> Leave Report </span>
            </div>
            <div class="col-md-3 pR0" style="z-index: 1;">
                <ob-select2 :inModal="false" :options="LeaveReportTypeOptions" v-model.trim="LeaveReportType"></ob-select2>
            </div>
            <div class="col-md-3 pR0">
                <ob-date-time-picker id="createDate" placeholder="Select Date" :options="options1" :inputvalue="Year" @updated="(v) => this.Year = v" v-model.trim="Year"></ob-date-time-picker>
            </div>
        </div>
        <div class="row">
             <div class="col-md-12">
                   <template v-if="!IsAjaxCallCompleted">
                            <ob-spinner loading-text="Loading..."></ob-spinner>
                 </template>
                 <template v-else>
                        <template v-if="DoughnutChartData.length > 0">
                            <chart  :doughnutChartdata.sync="DoughnutChartData"> </chart>
                        </template>
                        <template v-else>
                                <div  class="text-center" v-if="IsAjaxCallCompleted">
                                    <div style="margin-bottom: 20px">
                                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_nodata.svg`">
                                    </div>
                                    <div style="font-size: 14px;">No data available to display!</div>
                                </div>
                      </template>
                  </template>
            </div>
        </div>
    </div>
</template>
<script>
import c from 'Vue/Core/constants.js'
import utils from "Vue/Core/utils.js";
import chart from "./DashboardChart.vue";

export default {
    props: ["content"],
    data() {
        return {

            ApprovedLeaves : true,
            BalanceLeaves : false,
            PendingLeaves : false,
            LeaveData : '',
            DoughnutChartData: [],
            Year:moment().format("YYYY"),

             options1: {
                minDate: moment('01/01/1970').format('MM/DD/YYYY'),
               // maxDate: moment().add(10, 'years'),
                format: 'YYYY',
                dayViewHeaderFormat: 'YYYY',
                ignoreReadonly: true,
                widgetPositioning: {
                horizontal: 'right',
                vertical: 'bottom'
                }
            },
            IsAjaxCallCompleted:false,
            LeaveReportType:'Balance',
            LeaveReportTypeOptions: {
                minimumResultsForSearch: -1,
                dropdownAutoWidth : true,
                placeholder: {
                    id: "-1",
                    text: "Select"
                },
                data: [{
                    id:'Taken',text:'Taken'
                },
                {
                    id:'Balance',text:'Balance'
                },
                {
                    id:'Pending',text:'Pending'
                }
                ]
            },
         }
    },
    components: {
       'chart':chart
    },
    watch:{
       Year(val)
       {
         if(val != null && val != ''){
          this.getLeaveCount(val)
          this.LeaveReportType = 'Balance'
         }
       },
       LeaveReportType(val)
       {
           if(val=='Taken')
           {
               this.onAppliedLeavesClick()
           }
           else if(val == 'Balance'){
               this.onBalancedLeavesClick()
           }
           else{
               this.onPendingLeavesClick()
           }
       }
    },
    computed: {
           EmployeeId() {
            return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
           },
    },
    created()
    {
        var currentYear = moment().format("YYYY")
        this.getLeaveCount(currentYear)
    },
    methods: {
        BalanceLeavesSum()
        {
            if(this.LeaveData && this.LeaveData.Balance)
            {
                this.$emit('BalanceLeavesSum', this.LeaveData.Balance)
                return this.LeaveData.Balance
            } else return 0
        },
        AppliedLeavesSum()
        {
            if(this.LeaveData && this.LeaveData.Approved)
            {
                this.$emit('AppliedLeavesSum', this.LeaveData.Approved)
                return this.LeaveData.Approved
            } else return 0
        },
        PendingLeavesSum()
        {
            if(this.LeaveData && this.LeaveData.Pending)
            {
                this.$emit('PendingLeavesSum', this.LeaveData.Pending)
                return this.LeaveData.Pending
            } else return 0
        },
        TotalLeavesSum()
        {
            if(this.LeaveData && this.LeaveData.TotalLeaveCount)
            {
                this.$emit('TotalLeavesSum', this.LeaveData.TotalLeaveCount)
                return this.LeaveData.TotalLeaveCount
            } else return 0
        },
        onAppliedLeavesClick()
        {
          this.DoughnutChartData = [] ;
          this.ApprovedLeaves = true;
          this.BalanceLeaves = false;
          this.PendingLeaves = false;
          if(this.AppliedLeavesSum() > 0)
          {
          this.DoughnutChartData = this.LeaveData.ApprovedLeaves.filter(v=>v.Count != 0);
          }
        },
        onBalancedLeavesClick()
        {
            this.DoughnutChartData = [] ;
            this.ApprovedLeaves = false;
            this.BalanceLeaves = true;
            this.PendingLeaves = false;
            if(this.BalanceLeavesSum() > 0)
            {
               this.DoughnutChartData = this.LeaveData.BalanceLeaves.filter(v=>v.Count != 0);
            }
        },
        onPendingLeavesClick(){
            this.DoughnutChartData = [] ;
            this.ApprovedLeaves = false;
            this.BalanceLeaves = false;
            this.PendingLeaves = true;
            if(this.PendingLeavesSum() > 0)
            {
               this.DoughnutChartData = this.LeaveData.PendingLeaves.filter(v=>v.Count != 0);
            }
        },
        getLeaveCount(year)
        {
            this.IsAjaxCallCompleted = false
            ajax.get(`/Leave/${this.EmployeeId}/${year}/Count`, {}, (res) => {
                this.LeaveData = res.data.LeaveData;
                this.onBalancedLeavesClick()
                this.AppliedLeavesSum()
                this.BalanceLeavesSum()
                this.PendingLeavesSum()
                this.TotalLeavesSum()
                this.IsAjaxCallCompleted = true
            })
        }
    }
}
</script>
<style scoped>

.control-label {
    color: #8695A5;
}
.form-control-static {
    color: #475259;
    font-weight: 600;
}
.section-title {
    color: #4D92DF;
    font-size: 13px;
    margin: 0 0 15px;
    font-weight: 600;
}
.section{
    color: rgb(103, 106, 108);
    font-size: 13px;
    margin: 0 0 15px;
    font-weight: 600;
}
.label {
    border-radius: 10px;
}
.section-holder__value{
    color: #123261;
    font-size: 28px;
    font-weight: 700;
    line-height: 50px;
}
.section-holder__label{
    font-size: 14px;
    font-weight: 600;
}
.leave-buttons{
    padding: 10px;
    display: inline-block;
    margin: 4px 0;
    cursor: pointer;
    font-size: 12px;
}
.leave-buttons-selected{
    background: #4A90E2;
    color: white;
}
.text-center{
    margin-top: 85px
}
.title{
  color: #19223d;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
  margin-right: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/ESSDashboard/LeaveReport.vue